/**
 * @fileoverview PUT handler for the "/companies/:company_id/custom_roles/update_custom_role/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomRolesUpdateCustomRoleIdCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdCustomRolesUpdateCustomRoleIdProps,
  CompaniesCompanyIdCustomRolesUpdateCustomRoleIdResult,
} from "./types";

export const putCompaniesCompanyIdCustomRolesUpdateCustomRoleId = reactQueryMutationAdapter(
  companiesCompanyIdCustomRolesUpdateCustomRoleIdCacheKeys,
  (
    props: PutCompaniesCompanyIdCustomRolesUpdateCustomRoleIdProps
  ): Promise<CompaniesCompanyIdCustomRolesUpdateCustomRoleIdResult> => {
    // manipulate props here as needed {  }
    return fetch(`/companies/${props.companyId}/custom_roles/update_custom_role/${props.id}`, "PUT", props.body);
  }
);
